import { useEffect, useState } from "react";
import debounce from "lodash/debounce";

// Tailwind breakpoints
const breakpoints: { name: string; minWidth: number }[] = [
    { name: "2xl", minWidth: 1536 },
    { name: "xl", minWidth: 1280 },
    { name: "lg", minWidth: 1024 },
    { name: "md", minWidth: 768 },
    { name: "sm", minWidth: 640 },
    { name: "base", minWidth: 0 }
];

function getCurrentBreakpoint(screenWidth: number): string {
    return breakpoints.find(breakpoint => screenWidth >= breakpoint.minWidth)?.name ?? "base";
}

export default function useBreakpoint() {
    const [screenWidth, setScreenWidth] = useState(typeof window !== "undefined" ? window.innerWidth : 0);
    const [breakpoint, setBreakpoint] = useState(() => getCurrentBreakpoint(screenWidth));

    useEffect(() => {
        if (typeof window === "undefined") return;

        const handleResize = () => {
            const newWidth = window.innerWidth;
            setScreenWidth(newWidth);
            setBreakpoint(getCurrentBreakpoint(newWidth));
        };

        const debouncedResize = debounce(handleResize, 50);

        debouncedResize(); // Run once on mount
        window.addEventListener("resize", debouncedResize);

        return () => {
            debouncedResize.cancel();
            window.removeEventListener("resize", debouncedResize);
        };
    }, []);

    return { breakpoint };
}
